import Phaser from 'phaser';
import { config, editorConfig } from './config.js';

// Check if we're in editor mode
const isEditorMode = window.location.pathname === '/editor' ||
                     window.location.pathname === '/editor/';

// Initialize the appropriate game mode
const gameConfig = isEditorMode ? editorConfig : config;
const game = new Phaser.Game(gameConfig);

// Handle window resize
window.addEventListener('resize', () => {
  game.scale.refresh();
});

// Export for debugging
window.game = game;
window.isEditorMode = isEditorMode;
